import { http } from '../request'
import { expectArrayData } from './shared'

export interface SemesterDto {
  id: number
  academicYearId: number
  academicYearName?: string | null
  name: string
  typeId?: number | null
  typeName?: string | null
  startDate: string
  endDate: string
  isCurrent?: boolean | null
  sort?: number
}

interface CreateSemesterRequest {
  academicYearId: number
  typeId: number
  startDate: string
  endDate: string
  sort?: number
}

interface UpdateSemesterRequest {
  typeId?: number
  startDate?: string
  endDate?: string
  sort?: number
}

export const semesterApi = {
  async list(academicYearId?: number): Promise<SemesterDto[]> {
    const response = await http.get<SemesterDto[]>('/academic/semesters', { academicYearId })
    return expectArrayData<SemesterDto>(response.data, '/academic/semesters')
  },

  async create(payload: CreateSemesterRequest): Promise<SemesterDto> {
    const response = await http.post<SemesterDto>('/academic/semesters', payload)
    return response.data
  },

  async update(id: number, payload: UpdateSemesterRequest): Promise<SemesterDto> {
    const response = await http.put<SemesterDto>(`/academic/semesters/${id}`, payload)
    return response.data
  },

  async remove(id: number): Promise<void> {
    await http.delete(`/academic/semesters/${id}`)
  },

  async setCurrent(id: number, force = false): Promise<SemesterDto> {
    const response = await http.put<SemesterDto>(`/academic/semesters/${id}/set-current?force=${String(force)}`)
    return response.data
  }
}
